import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"12\" cy=\"12\" r=\"10.8\" fill=\"url(#liga_svg__a)\"></circle><circle cx=\"12\" cy=\"12\" r=\"9.6\" fill=\"url(#liga_svg__b)\"></circle><path fill=\"#181A1F\" d=\"M4.8 9.114v6h1.938v-4.247h10.523v4.247H19.2v-6z\"></path><defs><linearGradient id=\"liga_svg__a\" x1=\"17.4\" x2=\"4.8\" y1=\"20.4\" y2=\"3.6\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#178A35\"></stop><stop offset=\"1\" stop-color=\"#31FF66\"></stop></linearGradient><linearGradient id=\"liga_svg__b\" x1=\"12\" x2=\"18\" y1=\"21.6\" y2=\"3.6\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#178A35\"></stop><stop offset=\"1\" stop-color=\"#27DB55\"></stop></linearGradient></defs>", 4)
  ])))
}
export default { render: render }